export enum EargoGeneration {
  FIVE = "EARGO_FIVE",
  SIX = "EARGO_SIX",
  SEVEN = "EARGO_SEVEN",
  EIGHT = "EARGO_EIGHT",
  SE = "EARGO_SE",
}

export enum EargoGenerationHumanFriendly {
  FIVE = "Eargo 5",
  SIX = "Eargo 6",
  SEVEN = "Eargo 7",
  EIGHT = "Eargo 8",
  SE = "Eargo SE",
}
